<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'FACILITIES'" [breadcrumb]="''" [count]="count"
    icon="fa-clinic-medical">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="facilityGridAutoExpandSwitch" [storageKey]="'facilities-list-expand'"
                    [titleKey]="'AUTO-EXPAND'" (collapsibleToggle)="enableAutoExpand=$event" class="mr-4">
                </app-advanced-mode>
                <app-advanced-mode id="facilitiesGridAdvancedSwitch" [storageKey]="'facilities-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView" [navigable]="true"
            [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" [kendoGridSelectBy]="" (dataStateChange)="dataStateChange($event)"
            (cellClick)="onCellClick($event)" [selectable]="{ mode: 'single' }">
            <kendo-grid-messages noRecords="{{ 'NO-FACILITIES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="name" title="{{'NAME' | translate}}" [width]="100">
            </kendo-grid-column>
            <kendo-grid-column class="ellipsis-text" field="description" title="{{'DESCRIPTION' | translate}}"
                [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span title="{{dataItem.description}}">{{dataItem.description}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="telephoneNumber" title="{{ 'PHONE' | translate }}" [width]="40">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.telephoneNumber | phone}}</span>
                    <span *ngIf="dataItem.telephoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                        translate}}&nbsp;{{dataItem.telephoneNumberExtension}}</span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-phone-filter [filter]="filter" filterField="telephoneNumber"
                        [phoneNumberMask]="phoneNumberMask">
                    </app-phone-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="npi" title="{{ 'FACILITY-NPI' | translate }}" [width]="40">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="30" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'], dataItem['npi'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
            <ng-template kendoGridDetailTemplate let-dataItem
                [kendoGridDetailTemplateShowIf]="showDetailsOnlyIfAddress">
                <section *ngIf="dataItem.address" class="ml-3">
                    <div *ngIf="dataItem.address.streetLine">{{dataItem.address.streetLine}}</div>
                    <div *ngIf="dataItem.address.streetLineAdditional">
                        {{dataItem.address.streetLineAdditional}}</div>
                    <div>
                        <span *ngIf="dataItem.address.city">{{dataItem.address.city}},&nbsp;</span>
                        <span *ngIf="dataItem.address.county">{{dataItem.address.county}},&nbsp;</span>
                        <span *ngIf="dataItem.address.state">{{dataItem.address.state.code}}&nbsp;</span>
                        <span *ngIf="dataItem.address.postalCode">{{dataItem.address.postalCode}}
                        </span>
                    </div>
                    <div *ngIf="dataItem.address.country">
                        {{dataItem.address.country.code}}
                    </div>
                </section>
            </ng-template>
        </kendo-grid>
        <div class="float-right mt-3 mb-3">
            <button kendoButton [primary]="false" type="button" (click)="addHandler()">
                {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
        </div>
    </div>
</div>

<!--Add/Edit form-->
<app-facility-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-facility-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedFacility.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>